import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Row, Select } from "antd";
import useAuth from "../../../../hooks/useAuth";
import useMessage from "../../../../hooks/useMessage";
import getDocName from "../../../../utils/getDocTitle";
import usePurchase from "../../../../hooks/usePurchase";
import SignUpModal from "../../../../components/Modal/SignUpModal";
import { useCurrencyCourse } from "../../../../hooks/useCurrencyCourse";
import { DocumentsContext } from "../../../../contexts/DocumentsProvider";
import { useHistoricalCourse } from "../../../../hooks/useHistoricalCourse";
import { CRYPTOCURRENCY_ARRAY } from "../../../../constants/CryptocurrencyArray";
import PurchaseConfirmModal from "../../../../components/Modal/PurchaseConfirmModal";
import withLayout from "../../../../hoc/withLayout";
import Result from "./Result";
import {
  TitlePageUi,
  HeaderPhoneFormUi,
  InputNumberUi,
  SpinUi,
  SelectUi,
  CollapseUi,
} from "../../../../components/ui";
import {
  IconAndroid,
  IconApple,
  IconExodus,
  IconFileText,
  IconiPhone,
} from "../../../../utils/Icons";

const { Option } = Select;

const Generator = () => {
  const { t } = useTranslation();
  const basePath = "wallets.form.";

  const { type, id } = useParams();
  const { user } = useAuth();

  const { getProductByApiId, isLoading } = useContext(DocumentsContext);
  const product = getProductByApiId(Number(id));

  const [mobile, setMobile] = useState({
    battery: 50,
    charge: false,
    mobNetwork: 1,
    mobConnect: "none-connect",
    timeScreen: null,
    eSim: false,
    additional: null,
  });

  const [state, setState] = useState({
    theme: "dark",
    amount: null,
    chain: "ETH",
    currency: CRYPTOCURRENCY_ARRAY[0],
  });

  const { showErrorMessage } = useMessage();

  const onCurrencyChange = (key) => {
    const currency = CRYPTOCURRENCY_ARRAY.find((item) => item.key === key);
    setState((prevState) => ({ ...prevState, currency }));
  };

  const idCoin = state.currency.value;
  const coin = useCurrencyCourse(idCoin);
  const historicalData = useHistoricalCourse(state.currency.value);
  const title = getDocName(product);

  const splitAmount = (amount = 0) => {
    const [mainSum, decimalPart = "00"] = String(amount).split(".");
    return { mainSum, decimalPart };
  };

  const { mainSum, decimalPart } = splitAmount(coin?.lastPrice);

  const chartOptions = {
    chart: {
      id: "crypto-chart",
      type: "line",
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    colors: [state.currency.color],
    stroke: {
      curve: "smooth",
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      show: false,
    },
    legend: {
      show: true,
    },
    markers: {
      size: 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "vertical",
        shadeIntensity: 1,
        colorStops: [
          {
            offset: 10,
            color: state.currency.color,
            opacity: 0.3,
          },
          {
            offset: 70,
            color: "#513264",
            opacity: 0.15,
          },
          {
            offset: 100,
            color: "#1b2134",
            opacity: 0.2,
          },
        ],
      },
    },
  };

  const chartSeries = [
    {
      name: "Цена на этот период",
      data: historicalData.data,
      type: "area",
    },
  ];

  // Purchase start >>>>>>>>>

  const onCancel = () => setConfirmModalOpen(false);

  const errorForm = (err) => {
    showErrorMessage(
      t(
        err?.response?.data?.message
          ? `apiErrors.${err?.response?.data?.message}`
          : `formMain.message.error`
      )
    );
  };

  const {
    showWatermark,
    mutate,
    processing,
    signUpModalOpen,
    closeSignUpModal,
    openSignUpModal,
    confirmModalOpen,
    setConfirmModalOpen,
  } = usePurchase({ product, onError: errorForm });

  const onConfirm = () => {
    onCancel();
    mutate({
      id,
      type,
      state,
      mobile,
      coin,
      idCoin,
      mainSum,
      decimalPart,
      historicalData,
      chartOptions,
      chartSeries,
    });
  };

  const successForm = () => setConfirmModalOpen(true);

  // Purchase end <<<<<<<<<

  if (isLoading || !product) {
    return (
      <div className="spin-loader">
        <SpinUi size="54" />
      </div>
    );
  }

  return (
    <>
      <Row>
        <Col lg={24} md={24} sm={24} xs={24}>
          <TitlePageUi
            name={title}
            addonIcon={<IconExodus width="24" height="24" fill="#00c39a" />}
            suffixIcon={
              <div className="price">
                {t(`formMain.price`)}
                {product.price_with_discount ? (
                  <div className="price-value">
                    <s>${product.price}</s>{" "}
                    <i>${product.price_with_discount}</i>
                  </div>
                ) : (
                  <div className="price-value">${product.price}</div>
                )}
              </div>
            }
          />
        </Col>
      </Row>
      <div className="custom-row">
        <div className="form box">
          <Form
            name="wec"
            layout="vertical"
            onFinish={user ? successForm : openSignUpModal}
            onFinishFailed={errorForm}
            autoComplete="off"
          >
            <Row align="middle">
              <Col lg={24} md={24} sm={24} xs={24}>
                <h6 className="text-center-sm mb-30">{t(`formMain.title`)}</h6>
              </Col>

              <Col lg={12} md={12} sm={12} xs={24}>
                <div className="system_title">
                  <p>{t(`formMain.system`)}</p>
                  <span>
                    {type === "ios" ? (
                      <s>
                        iOS <IconApple width="22" height="22" fill="#00c39a" />
                      </s>
                    ) : (
                      <s>
                        Android{" "}
                        <IconAndroid width="22" height="22" fill="#00c39a" />
                      </s>
                    )}
                  </span>
                </div>
              </Col>
            </Row>

            <CollapseUi
              defaultActiveKey={["1", "2"]}
              className="form-collapse"
              items={[
                {
                  key: 1,
                  label: (
                    <>
                      <IconiPhone width="20" height="20" fill="#ababab" />
                      {t(`formMain.formCollapse.phone`)}
                    </>
                  ),
                  children: (
                    <HeaderPhoneFormUi
                      type={type}
                      setMobileValue={(field, value) =>
                        setMobile((prevState) => ({
                          ...prevState,
                          [field]: value,
                        }))
                      }
                    />
                  ),
                },
                {
                  key: 2,
                  label: (
                    <>
                      <IconFileText width="20" height="23" fill="#ababab" />
                      {t(`formMain.formCollapse.content`)}
                    </>
                  ),
                  children: (
                    <Row className="w-full">
                      <Col lg={24} md={24} sm={24} xs={24}>
                        <InputNumberUi
                          name={"amount"}
                          label={t(`${basePath}exodus.amountCoin`)}
                          placeholder="100"
                          onChange={(value) =>
                            setState((prevState) => ({
                              ...prevState,
                              amount: value,
                            }))
                          }
                          errorMess={t(`formMain.message.requiredField`)}
                        />
                      </Col>

                      <Col lg={24} md={24} sm={24} xs={24}>
                        <SelectUi
                          name={`currency`}
                          label={t(`${basePath}exodus.currency`)}
                          defaultValue={"USDT"}
                          onChange={onCurrencyChange}
                          errorMess={t(`formMain.message.requiredField`)}
                        >
                          {CRYPTOCURRENCY_ARRAY.map((item) => (
                            <Option key={`option-${item.key}`} value={item.key}>
                              <img src={item.icon_binance} alt="" />
                              {item.name}
                            </Option>
                          ))}
                        </SelectUi>
                      </Col>

                      {state.currency.chain && (
                        <Col lg={24} md={24} sm={24} xs={24}>
                          <SelectUi
                            name={`network`}
                            label={t(`${basePath}exodus.network`)}
                            defaultValue={"ETH"}
                            onChange={(value) =>
                              setState((prevState) => ({
                                ...prevState,
                                chain: value,
                              }))
                            }
                            errorMess={t(`formMain.message.requiredField`)}
                          >
                            <Option value="none">
                              {t(`${basePath}exodus.noNet`)}
                            </Option>
                            <Option value="ETH">Ethereum (ETH)</Option>
                            <Option value="TRX">Tron (TRX)</Option>
                            <Option value="ALGO">Algorand (ALGO)</Option>
                            <Option value="SOL">Solana (SOL)</Option>
                            <Option value="AVAXC">
                              Avalanche C-Chain (AVAXC)
                            </Option>
                            <Option value="POLYGON">Polygon (POLYGON)</Option>
                            <Option value="BSC">BNB Smart Chain (BSC)</Option>
                          </SelectUi>
                        </Col>
                      )}
                    </Row>
                  ),
                },
              ]}
            />

            <div className="btn-group mt-30">
              <div className="btn-persv">
                <Button htmlType="submit">{t(`formMain.btn.png`)}</Button>
              </div>
            </div>
          </Form>
        </div>

        {/* Result Component */}
        <Result
          id={id}
          type={type}
          state={state}
          mobile={mobile}
          coin={coin}
          idCoin={idCoin}
          mainSum={mainSum}
          decimalPart={decimalPart}
          historicalData={historicalData}
          chartOptions={chartOptions}
          chartSeries={chartSeries}
          processing={processing}
          showWatermark={showWatermark}
        />

        {/* Modal Unregistered User */}
        <SignUpModal showModal={signUpModalOpen} onCancel={closeSignUpModal} />

        {/* Modal Purchase Confirm */}
        <PurchaseConfirmModal
          product={product}
          showModal={confirmModalOpen}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      </div>
    </>
  );
};

export default withLayout(Generator, "gen-page");
